/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateUpdateHazardForm } from '../../models/create-update-hazard-form';
import { HazardDto } from '../../models/hazard-dto';

export interface DeleteAllAndCreateNew$Params {

/**
 * The customer id
 */
  customerId: number;
      body: CreateUpdateHazardForm
}

export function deleteAllAndCreateNew(http: HttpClient, rootUrl: string, params: DeleteAllAndCreateNew$Params, context?: HttpContext): Observable<StrictHttpResponse<HazardDto>> {
  const rb = new RequestBuilder(rootUrl, deleteAllAndCreateNew.PATH, 'post');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HazardDto>;
    })
  );
}

deleteAllAndCreateNew.PATH = '/customers/{customerId}/hazards/delete-all-and-create-new';
